export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9709.93768a1d.jpg";